import type { FC } from "react";

import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";
import { GenericSearchFormCriteria } from "../../../oldComponents/GenericSearchFormCriteria";
import type { ValidationReport } from "../../../types/entities/validationReport";
import { ValidationReportsTable } from "./ValidationReportsTable";

export const ValidationReportsPage: FC<NoneOwnProps> = () => {
    const table = <ValidationReportsTable />;
    const searchForm = (
        // <SearchForm>
        <GenericSearchFormCriteria />
        // </SearchForm>
    );

    return (
        <PageLayout>
            <PageTitle translationKey="menu.validationReports" />
            <ResourceManager<ValidationReport>
                useDataGroup
                dataMapperKey="validationReportTableData"
                resource={ResourceName.VALIDATION_REPORTS}
                table={table}
                searchForm={searchForm}
                actions={[Actions.EXPORT]}
            />
        </PageLayout>
    );
};
